import React from 'react';
import mixpanel from 'mixpanel-browser';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import { getApiBaseUrl } from 'shared/helper/request';
var GroupedLoginDropdown = function GroupedLoginDropdown(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'dropdown-menu' : _ref$className,
    displayed = _ref.displayed,
    loggedIn = _ref.loggedIn,
    _ref$onLinkClicked = _ref.onLinkClicked,
    onLinkClicked = _ref$onLinkClicked === void 0 ? function () {} : _ref$onLinkClicked,
    siteLanguage = _ref.siteLanguage;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var params = "?redirect_uri=".concat(window.location.origin, "/login?logout=1");
  var handleLogout = function handleLogout(e) {
    e.preventDefault();
    e.stopPropagation();
    onLinkClicked('Logout');
    try {
      mixpanel.reset();
    } catch (err) {
      // silently ignore reset failure
    }
    var logoutUrl = "".concat(getApiBaseUrl(), "/api/auth/logout").concat(params);
    setTimeout(function () {
      window.location.href = logoutUrl;
    }, 500);
  };
  return /*#__PURE__*/React.createElement("ul", {
    className: "".concat(className, " ").concat(displayed ? 'show' : '')
  }, !loggedIn ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: function onClick() {
      return onLinkClicked('Login');
    },
    to: "/".concat(siteLanguage, "/login"),
    className: "welcome nav-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Login"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "d-none d-sm-block nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: function onClick() {
      return onLinkClicked('Sign Up');
    },
    to: "/".concat(siteLanguage, "/register"),
    className: "welcome nav-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Sign Up"
  })))) : null, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link myAccountLinks",
    "aria-label": t('rubriq.go-to-aje'),
    href: "".concat(getApiBaseUrl(), "/researcher"),
    onClick: function onClick() {
      return onLinkClicked('Go to AJE');
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.go-to-aje"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "nav-link myAccountLinks",
    onClick: function onClick() {
      return onLinkClicked('Settings');
    },
    to: "/".concat(siteLanguage, "/account")
  }, /*#__PURE__*/React.createElement(T, {
    source: "settings"
  }))), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link trackable-link myAccountLinks",
    "aria-label": t('get-help'),
    href: siteLanguage === 'cn' ? 'https://customer-support.aje.com/portal/zh/kb/rubriq' : 'https://customer-support.aje.com/portal/en/kb/rubriq',
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: function onClick() {
      return onLinkClicked('Get Help');
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: "get-help"
  }))), loggedIn ? /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "logout-action nav-link myAccountLinks w-100",
    "aria-label": t('Log out'),
    onClick: handleLogout
  }, /*#__PURE__*/React.createElement("span", {
    className: "nav-link trackable-link myAccountLinks"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Log out"
  })))) : null);
};
export default GroupedLoginDropdown;